// extracted by mini-css-extract-plugin
export default {"container":"ContinueCreatingProject_container__TZoGx"};